/* lg-facet-colour.js - Block 79 (4 Sep). Colour facet behaves as single-select.

   Shopify's Search & Discovery filters are multi-select and the theme cannot
   change that server-side, so the constraint is enforced in the browser: when a
   colour value is ticked, every other ticked value in the SAME colour group is
   unticked before Dawn serialises the form.

   Two details make this work:

   1. Capture phase on document. Dawn's FacetFiltersForm binds its handler on
      the facets form (bubble phase), so a capture-phase listener higher up runs
      first and the inputs are already corrected by the time Dawn reads them.

   2. Delegation on document, never per-element binding. Dawn re-renders the
      whole facets block from a fetch on every filter change, which would
      discard any listener attached to an input or to the group itself.

   Desktop and the mobile drawer each render their own [data-lg-facet="colour"]
   group; scoping to the closest one keeps them independent. */
(function () {
  'use strict';

  if (window.lgFacetColourBound) return; // double-bind guard
  window.lgFacetColourBound = true;

  var GROUP = '[data-lg-facet="colour"]';

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || input.tagName !== 'INPUT') return;
      if (input.type !== 'checkbox' && input.type !== 'radio') return;
      if (!input.checked) return; // clearing one needs no help
      if (typeof input.closest !== 'function') return;

      var group = input.closest(GROUP);
      if (!group) return;

      var all = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      Array.prototype.forEach.call(all, function (other) {
        if (other !== input && other.checked) other.checked = false;
      });
    },
    true
  );
})();
